<div class="bg-img" [ngStyle]="{backgroundImage:'url(assets/images/sat.jpg)'}">
    <div class="bg-blue">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-4">
                    <img src="../assets/images/logos/Strait_Air_SPOT_neg.png" alt="logo" class="sat-logo img-fluid">
                </div>
                <div class="col-lg-6 col-md-8">
                    <div class="row">
                        <div class="col-lg-4 col border-left ps-5">
                            <img src="../assets/images/logos/excellence.svg" alt="excellence">
                            <h5 class="text-white mb-0">{{currentYear - 2000}} Years <br class="res-none">Of Excellence</h5>
                        </div>
                        <div class="col-lg-4 col border-left ps-5">
                            <img src="../assets/images/logos/location.svg" alt="excellence">
                            <h5 class="text-white mb-0">9 Own Offices<br class="res-none"> In Europe</h5>
                        </div>
                        <div class="col-lg-4 col border-left ps-5">
                            <img src="../assets/images/logos/time.svg" alt="excellence">
                            <h5 class="text-white mb-0">24x7<br class="res-none"> Support</h5>
                        </div>
                    </div>
                    
                </div>
            </div>
    </div>
   </div>
</div>
